const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_authenticated-user/superuser/statistikk/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated-user/superuser/statistikk/")({
  head: () => ({
    meta: [{
      title: "Superuser statistikk | Alice & Bob"
    }]
  }),
  loader: async () => {
    const res = await routeLoaderApiClient.superuser.reports["successfully-tinglyst-documents"].$get();
    if (res.ok === false) {
      throw new Error("Failed to fetch successfully tinglyst documents statistis");
    }
    const successfullyTinglystDocuments = await res.json();
    return {
      successfullyTinglystDocuments
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});